import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DmCartAdd } from 'src/app/components/carrinho/dm-cart-add/dm-cart-add.component';
import { FormsModule } from '@angular/forms';
import { LoaderModule } from '../../loader/loader/loader.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PipeModule } from '../../pipe/pipe.module';
import { ComboDataSelectModule } from '../../combo/combo-data-select/combo-data-select.module';
import { PartialModule } from '../../partial/partial.module';
import { BtnCartAddModule } from '../btn-cart-add/btn-cart-add.module';

@NgModule({
    declarations: [
        DmCartAdd
    ],
    exports: [
        DmCartAdd
    ],
    imports: [
        FormsModule,
        CommonModule,
        LoaderModule,
        LazyLoadImageModule,
        PipeModule,
        ComboDataSelectModule,
        PartialModule,
        BtnCartAddModule
    ]
})
export class CartAddModule{} 
